import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchLeaderboard } from "../redux/slices/userSlice";
import { Link } from "react-router-dom";

const UserLeaderBoard = () => {

  const dispatch = useDispatch();

  const { leaderboard, leaderboardPagination, loading, error } =
    useSelector((state) => state.users);

  const [search, setSearch] = useState("");
  const [type, setType] = useState("user");
  const [page, setPage] = useState(1);

  const limit = 10;

  useEffect(() => {
    dispatch(fetchLeaderboard({ page, limit, search, type }));
  }, [dispatch, page, search, type]);

  const totalPages = leaderboardPagination?.totalPages || 1;

  return (
    <div className="container">

      <div className="row d-flex justify-content-center mt-5">
        <div className="col-lg-10 col-xs-12 col-sm-12">

          <div className="card">
            <div className="card-body">

              <h5>🏆 Leaderboard</h5>

              <hr />

              {/* 🔎 Search + Type */}
              <div className="row mb-3">

                <div className="col-md-4">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search name..."
                    value={search}
                    onChange={(e) => {
                      setSearch(e.target.value);
                      setPage(1);
                    }}
                  />
                </div>

                <div className="col-md-3">
                  <select
                    className="form-control"
                    value={type}
                    onChange={(e) => {
                      setType(e.target.value);
                      setPage(1);
                    }}
                  >
                    <option value="user">Users</option>
                    <option value="servicemen">Servicemen</option>
                  </select>
                </div>

              </div>

              {loading && <p>Loading Leaderboard...</p>}
              {error && <p className="text-danger">{error}</p>}

              {!loading && leaderboard.length === 0 && (
                <p>No users on Leaderboard.</p>
              )}

              {!loading && leaderboard.length > 0 && (
                <>

                  <table className="table table-bordered mt-3">

                    <thead className="table-info">
                      <tr>
                        <th>Rank</th>
                        <th>Profile</th>
                        <th>Name</th>
                        <th>Points</th>
                        <th>Referral Code</th>
                        
                      </tr>
                    </thead>

                    <tbody>

                      {leaderboard.map((user) => (
                        <tr key={user._id}>

                          <td>
                            {user.rank === 1
                              ? "🥇"
                              : user.rank === 2
                              ? "🥈"
                              : user.rank === 3
                              ? "🥉"
                              : `#${user.rank}`}
                          </td>

                          <td>
                            <img
                              src={
                                user?.userImage
                                  ? user.userImage.startsWith("http")
                                    ? user.userImage
                                    : `${process.env.REACT_APP_UPLOADS_URL}${user.userImage}`
                                  : "https://cdn-icons-png.flaticon.com/512/149/149071.png"
                              }
                              alt="User"
                              width="40"
                              height="40"
                              style={{ borderRadius: "50%" }}
                            />
                          </td>

                          <td>{user.name}</td>

                          <td>{user.points}</td>

                          <td>{user.referralCode}</td>


                        </tr>
                      ))}

                    </tbody>

                  </table>

                  {/* 📄 Pagination */}

                  <div className="d-flex justify-content-center mt-3">

                    <button
                      className="btn btn-sm btn-secondary me-2"
                      disabled={page === 1}
                      onClick={() => setPage(page - 1)}
                    >
                      Prev
                    </button>

                    <span className="align-self-center">
                      Page {page} of {totalPages}
                    </span>

                    <button
                      className="btn btn-sm btn-secondary ms-2"
                      disabled={page === totalPages}
                      onClick={() => setPage(page + 1)}
                    >
                      Next
                    </button>

                  </div>

                </>
              )}

            </div>
          </div>

        </div>
      </div>

    </div>
  );
};

export default UserLeaderBoard;